import type { ReactNode } from 'react';
import { cx } from '../lib/cx';

interface PageProps {
  /** Large title for top-level screens. */
  title?: ReactNode;
  /** Right side of the title row (e.g. the "+" button). */
  titleAction?: ReactNode;
  children: ReactNode;
  /** Extra bottom padding for the tab bar or a fallback main button. */
  bottomInset?: 'tabbar' | 'mainbutton' | 'none';
  className?: string;
}

export function Page({ title, titleAction, children, bottomInset = 'none', className }: PageProps) {
  return (
    <div
      className={cx(
        'min-h-dvh bg-bg text-text',
        bottomInset === 'tabbar' && 'pb-[calc(96px+env(safe-area-inset-bottom))]',
        bottomInset === 'mainbutton' && 'pb-[calc(112px+env(safe-area-inset-bottom))]',
        bottomInset === 'none' && 'pb-[calc(40px+env(safe-area-inset-bottom))]',
        className,
      )}
    >
      {title !== undefined && (
        <header className="flex items-center justify-between gap-3 px-4 pt-6 pb-4">
          <h1 className="text-[28px] font-bold leading-tight">{title}</h1>
          {titleAction}
        </header>
      )}
      {children}
    </div>
  );
}
